import type { DocViewerKind } from './doc-viewer';

// The Files viewer opening, in BI — SHARED CONTRACT with iOS `DocumentViewer` and Android `DocumentViewer`
// (keep the component name, the field keys and the enum values identical on all three surfaces).
//
// One src:198 itemSeen (evid 6), component `doc-viewer-open`, fired once per open of the viewer, carrying
//  - `file_kind`: markdown | html | image | video | wixel | pdf | csv | text | audio | doc | slides | sheet | none
//    (`none` = the classifier claims nothing, so the viewer shows its no-preview notice; the phones hand those
//    off to the OS instead of opening the viewer, so they never report `none`). `doc`/`slides`/`sheet` are
//    web-only kinds, a tracked divergence of the classifier (lib/doc-viewer).
//  - `platform`: web
// The outcome of the body load rides the existing `doc-viewer-content` loadFinish, which now carries the same
// `file_kind`. Ids, enums and counts only: never the file name, path or content.

export const DOC_VIEWER_OPEN_COMPONENT = 'doc-viewer-open';
export const DOC_VIEWER_BI_PLATFORM = 'web';

/**
 * Why a text body load ended, on the `doc-viewer-content` loadFinish only: `ok`, `too_large` (over the 2 MB
 * preview cap, which the viewer answers with its download hand-off), `http_<status>`, or `network` (anything
 * else). Guardian F.1 counted 29 failed loads in 48h, all html/text on web, with nothing to say which of these
 * they were (2026-11-01). Web-only for now: the phones' `document_content` reported no failures.
 */
export function docLoadOutcome(error: unknown): string {
  if (error == null) return 'ok';
  if (error instanceof Error && error.name === 'DocTooLargeError') return 'too_large';
  const status = error instanceof Error ? /^HTTP (\d{3})$/.exec(error.message)?.[1] : undefined;
  return status ? `http_${status}` : 'network';
}

/** The `additionalFields` every Files-viewer event carries. */
export function docViewerBiFields(kind: DocViewerKind | null): Record<string, string> {
  return { file_kind: kind ?? 'none', platform: DOC_VIEWER_BI_PLATFORM };
}
